import React from 'react'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import Divider from '@mui/material/Divider'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormGroup from '@mui/material/FormGroup'

export interface ColumnsPaneProps {
  columns: { name: string; title: string }[]
  hidden: string[]
  onToggle: (name: string) => void
  onReset: () => void
}

export function ColumnsPane({ columns, hidden, onToggle, onReset }: ColumnsPaneProps) {
  const visibleCount = columns.filter((c) => !hidden.includes(c.name)).length
  return (
    <>
      <FormGroup>
        {columns.map((c) => {
          const shown = !hidden.includes(c.name)
          const lastVisible = shown && visibleCount === 1
          return (
            <FormControlLabel
              key={c.name}
              disabled={lastVisible}
              control={<Checkbox size="small" checked={shown} />}
              label={c.title}
              onChange={() => {
                if (!lastVisible) onToggle(c.name)
              }}
            />
          )
        })}
      </FormGroup>
      <Divider />
      <Button aria-label="Reset columns" onClick={onReset} sx={{ textTransform: 'none' }}>
        Reset columns
      </Button>
    </>
  )
}
